export default {
  application: [],
  curApplication:{name:'-',props:{}},
}